import { DEFAULT_SLIPPAGE } from '@/config/consts'
import { WAD } from './calculateRedeemAmount'

export function calculateMinimumMint(depositAmount: bigint, rate: bigint, slippage?: number): bigint {
  if (!slippage) {
    slippage = DEFAULT_SLIPPAGE
  }
  const slippageAsBigInt = BigInt((slippage * WAD.number).toString())
  const minimumMint = (depositAmount * WAD.bigint) / rate
  const slippageAmount = (minimumMint * slippageAsBigInt) / WAD.bigint

  return minimumMint - slippageAmount
}
